
import * as Actions from './new-actions.js'

const initialState = {}

export default function reducer (state = initialState, action) {
  const key = action.category

  // modify state based on action types
  switch (action.type) {
    case Actions.GET_ASSESSMENT:
      return {
        ...state,
        [key]: {
          ...state[key],
          loading: true
        }
      }
    case Actions.GET_ASSESSMENT_SUCCESS:
      return {
        ...state,
        [key]: {
          ...state[key],
          loading: false,
          formData: action.value
        }
      }
    case Actions.GET_ASSESSMENT_FAILURE:
      return {
        ...state,
        [key]: {
          ...state[key],
          loading: false,
          error: true
        }
      }
    default:
      return state
  }
}
